// extracted by mini-css-extract-plugin
export default {"info":"duplicate-webcast_info__tF1m3","title":"duplicate-webcast_title__QuUFp"};